/**
 * Utilitários para manipulação de tokens JWT
 */

/**
 * Decodifica um token JWT sem verificar a assinatura
 */
function decodeToken(token: string): any | null {
  try {
    const parts = token.split('.')
    if (parts.length !== 3) {
      return null
    }
    
    const payload = parts[1]
    const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')))
    return decoded
  } catch (error) {
    console.error('Erro ao decodificar token:', error)
    return null
  }
}

/**
 * Verifica se um token JWT está expirado
 */
export function isTokenExpired(token: string): boolean {
  if (!token) return true
  
  const decoded = decodeToken(token)
  if (!decoded || !decoded.exp) {
    return true
  }
  
  const currentTime = Math.floor(Date.now() / 1000)
  return decoded.exp < currentTime
}

/**
 * Obtém o tempo restante até a expiração do token (em segundos)
 */
export function getTimeUntilExpiration(token: string): number {
  if (!token) return 0
  
  const decoded = decodeToken(token)
  if (!decoded || !decoded.exp) {
    return 0
  }
  
  const currentTime = Math.floor(Date.now() / 1000)
  const timeLeft = decoded.exp - currentTime
  return Math.max(0, timeLeft)
}

/**
 * Obtém informações sobre o token
 */
export function getTokenInfo(token: string): {
  isValid: boolean
  isExpired: boolean
  timeLeft: number
  payload: any | null
} {
  if (!token) {
    return { isValid: false, isExpired: true, timeLeft: 0, payload: null }
  }
  
  const decoded = decodeToken(token)
  if (!decoded) {
    return { isValid: false, isExpired: true, timeLeft: 0, payload: null }
  }
  
  const currentTime = Math.floor(Date.now() / 1000)
  const exp = decoded.exp || 0
  const timeLeft = Math.max(0, exp - currentTime)
  const isExpired = timeLeft === 0
  
  return {
    isValid: !!decoded.exp,
    isExpired,
    timeLeft,
    payload: decoded
  }
}

